import { ResetPassword } from '@/modules/authentication'
import { ForgottenPassword, Login } from '@/modules/login'
import { CreatePassword } from '@/modules/users/RegisterUser/CreatePassword'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'

export function NoAuthRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/create-password/:urlId" element={<CreatePassword />} />

        <Route path="/forgotten-password" element={<ForgottenPassword />} />

        <Route path="/reset-password/:urlId" element={<ResetPassword />} />

        <Route path="" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
